// Supermarkets the Compras tab can build a cart in. Both are VTEX storefronts;
// the worker mirrors this list in `worker/vtex.ts:STORES`.

export type StoreId = "wong" | "plazavea";

export const DEFAULT_STORE: StoreId = "wong";

export const STORE_IDS: StoreId[] = ["wong", "plazavea"];

export interface StoreExtraSku {
  skuId: string;
  sellerId: string;
  label: string;
}

export interface StoreMeta {
  id: StoreId;
  label: string;
  // Shared-cart handoff: opens the server-built week cart in the store's own
  // checkout, where the shopper pays.
  checkoutUrl: (orderFormId: string) => string;
  // One-tap extras not tied to an ingredient (e.g. PlazaVea's paid bag).
  extraSkus: StoreExtraSku[];
  // Where the shopper manages their saved addresses (Wong owns the address
  // book; PlazaVea addresses are typed in-app).
  addressesUrl: string | null;
}

export const STORE_META: Record<StoreId, StoreMeta> = {
  wong: {
    id: "wong",
    label: "Wong",
    checkoutUrl: (orderFormId) =>
      `https://www.wong.pe/checkout/?orderFormId=${encodeURIComponent(orderFormId)}#/cart`,
    // Wong's catalog has no paid-bag SKU (verified: "bolsa" only returns gift bags).
    extraSkus: [],
    addressesUrl: "https://www.wong.pe/account#/addresses",
  },
  plazavea: {
    id: "plazavea",
    label: "PlazaVea",
    checkoutUrl: (orderFormId) =>
      `https://www.plazavea.com.pe/checkout/?orderFormId=${encodeURIComponent(orderFormId)}#/cart`,
    extraSkus: [
      // "Bio Bolsa PLAZAVEA Mediana" — paid plastic-bag charge required at
      // checkout. Verified live: SKU 58122 / seller "1".
      { skuId: "58122", sellerId: "1", label: "Bolsas" },
    ],
    addressesUrl: null,
  },
};

export function otherStore(store: StoreId): StoreId {
  return store === "wong" ? "plazavea" : "wong";
}
